import { appBuildKey, getNativeAppBuildOnce, useGlobalState } from '@libs/client'
import { useEffect } from 'react'

const isKnownAppBuild = (appBuild: unknown): appBuild is number =>
  typeof appBuild === 'number' && appBuild > 0

/**
 * The mobile app build. /cartPage and /checkout seed the global state from the
 * `x-app-build` header. Pages the app opens directly (order tracking, contact…)
 * have no build there, so the hook asks the native `getUserInfo` bridge once and
 * stores the answer in the global state. The bridge is only called after mount,
 * so the first client render matches the server render.
 */
export const useAppBuild = () => {
  const [appBuild, setAppBuild] = useGlobalState<number>(appBuildKey)

  useEffect(() => {
    if (isKnownAppBuild(appBuild)) return
    let isActive = true
    getNativeAppBuildOnce().then((nativeAppBuild) => {
      if (isActive && nativeAppBuild) setAppBuild(nativeAppBuild)
    })
    return () => {
      isActive = false
    }
  }, [appBuild])

  return [appBuild, setAppBuild] as const
}
